import React from 'react';
import { FadeIn } from './FadeIn';
import { Wand2 } from 'lucide-react';
export function Mechanism() {
  return <section className="py-20 md:py-32 bg-lavender/20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-64 h-64 bg-lavender/30 rounded-full blur-3xl" data-id="element-149"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-64 h-64 bg-softBlue/30 rounded-full blur-3xl" data-id="element-150"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-151">
        <FadeIn data-id="element-152">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-soft mb-8" data-id="element-153">
            <Wand2 className="w-8 h-8 text-gold" data-id="element-154" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-darkText mb-8" data-id="element-155">
            El Flujo "Prompt-to-Product" (P2P)
          </h2>
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-soft text-left" data-id="element-156">
            <p className="text-lg text-lightText mb-6 leading-relaxed" data-id="element-157">
              InstaPrint AI no es un curso teórico; es un sistema operativo que
              te enseña a hablarle a la IA para que cree exactamente lo que el
              mercado de lujo está buscando.
            </p>
            <p className="text-lg text-lightText leading-relaxed" data-id="element-158">
              En lugar de "adivinar", utilizas nuestra{' '}
              <strong className="text-darkText font-bold" data-id="element-159">
                fórmula de 5 elementos
              </strong>{' '}
              para generar arte que se ve profesional, costoso y listo para
              imprimir.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}